<script setup lang="ts">
import { ref, watch, nextTick } from 'vue';

interface AppHeightTransitionProps {
  showKey: string;
  durationInMs?: number;
}

const props = withDefaults(defineProps<AppHeightTransitionProps>(), {
  durationInMs: 300,
});

const container = ref<HTMLElement | null>(null);

watch(
  () => props.showKey,
  async () => {
    if (!container.value) {
      return;
    }
    const el = container.value;

    const currentHeight = el.offsetHeight;

    await nextTick();
    const newHeight = el.scrollHeight;

    el.style.height = `${currentHeight}px`;
    el.style.transition = `height ${props.durationInMs}ms ease`;

    requestAnimationFrame(() => {
      el.style.height = `${newHeight}px`;
    });

    function onEnd(): void {
      el.style.height = '';
      el.style.transition = '';
      el.removeEventListener('transitionend', onEnd);
    }

    el.addEventListener('transitionend', onEnd);
  }
);
</script>

<template>
  <div ref="container" class="app-height-transition">
    <slot />
  </div>
</template>
